import Hls from "hls.js";

/**
 * Attach an HLS stream to a media element (video or audio).
 *
 * Safari plays HLS natively, so hls.js is only loaded where it is needed. This
 * keeps the bundle small and avoids the double-buffering you get from running
 * MSE behind Safari's own pipeline.
 */
export function attachStream(media: HTMLMediaElement, url: string): () => void {
  let hls: Hls | null = null;

  if (media.canPlayType("application/vnd.apple.mpegurl")) {
    media.src = url;
  } else if (Hls.isSupported()) {
    hls = new Hls({
      enableWorker: true,
      lowLatencyMode: true,
      // Keep a small buffer: the station is live, so old segments are wasted
      // memory and increase the delay before a viewer sees a switch.
      maxBufferLength: 12,
      backBufferLength: 8,
    });
    hls.loadSource(url);
    hls.attachMedia(media);
  } else {
    media.src = url;
  }

  return () => {
    hls?.destroy();
    hls = null;
    media.removeAttribute("src");
    media.load();
  };
}